/*
  Wunschfarbe RAL (Claude 2026-08).
  Gehoert zu snippets/bek-ral-wunschfarbe.liquid.

  Drei Aufgaben:
  1. "Wunschfarbe RAL" als zusaetzlichen Button in die Farbzeile des
     Familien-Selectors haengen und die native Optionszeile ausblenden,
     damit es nicht zwei Auswahlen fuer dieselbe Sache gibt.
  2. Das Eingabefeld genau dann zeigen, wenn die Wunschfarbe aktiv ist.
  3. Den Kauf blockieren, solange kein Farbton eingetragen wurde.

  Alles ueber Event-Delegation, damit nachgeladene Formulare (Quick-Shop)
  mitlaufen. Erkannt wird ueber Optionswerte, nicht ueber Options-Handles.
*/
(function () {
  'use strict';

  if (window.__bekRalInit) return;
  window.__bekRalInit = true;

  function scopeOf(el) {
    return el.closest('.product-section') || el.closest('.product-single') || document;
  }

  function isRalSelected(scope, ralValue) {
    var hit = false;
    scope.querySelectorAll('input[data-variant-input]').forEach(function (r) {
      if (r.checked && r.value === ralValue) hit = true;
    });
    scope.querySelectorAll('select[data-variant-input]').forEach(function (s) {
      if (s.value === ralValue) hit = true;
    });
    return hit;
  }

  /* Native Option auf einen Wert schalten und das Theme darueber informieren. */
  function setNative(scope, val) {
    var done = false;
    scope.querySelectorAll('input[data-variant-input]').forEach(function (r) {
      if (done || r.value !== val) return;
      if (!r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
      done = true;
    });
    if (done) return true;
    var sels = scope.querySelectorAll('select[data-variant-input]');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i];
      for (var j = 0; j < s.options.length; j++) {
        if (s.options[j].value !== val) continue;
        if (s.value !== val) {
          s.value = val;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  /* Passende Zeile im Familien-Selector suchen. data-ral-group listet die
     Label-ID-Praefixe in Prioritaetsreihenfolge, siehe Snippet-Kommentar. */
  function findRow(scope, wrap) {
    var groups = (wrap.getAttribute('data-ral-group') || '').split(',');
    for (var i = 0; i < groups.length; i++) {
      var pre = groups[i].replace(/^\\s+|\\s+$/g, '');
      if (!pre) continue;
      var row = scope.querySelector('.be-family-selector__options[aria-labelledby^="' + pre + '-"]');
      if (row) return row;
    }
    return null;
  }

  /* Wenn die Variante bereits als normaler Optionsbutton gerendert wird,
     diesen Button aufwerten. So gibt es nie einen zweiten Wunschfarben-Button. */
  function decorateNative(scope, ralValue) {
    var count = 0;
    scope.querySelectorAll('input[data-variant-input]').forEach(function (input) {
      if (input.value !== ralValue) return;
      var box = input.closest('.variant-input') || input.parentNode;
      var label = box && box.querySelector ? box.querySelector('label,.variant__button-label') : null;
      if (!label && input.id) {
        scope.querySelectorAll('label').forEach(function (candidate) {
          if (!label && candidate.htmlFor === input.id) label = candidate;
        });
      }
      if (!label) return;
      label.classList.add('bek-ral-native-opt');
      if (!label.querySelector('.bek-ral-dot')) {
        var dot = document.createElement('i');
        dot.className = 'bek-ral-dot';
        dot.setAttribute('aria-hidden', 'true');
        label.insertBefore(dot, label.firstChild);
      }
      count++;
    });
    return count;
  }

  /* Button nur dann in den Familien-Selector haengen, wenn kein nativer
     Wunschfarben-Optionsbutton existiert. */
  function inject(wrap) {
    var scope = scopeOf(wrap);
    var ralValue = wrap.getAttribute('data-ral-value') || 'Wunschfarbe RAL';
    if (wrap.getAttribute('data-bek-ral-injected') === '1') return;
    var row = findRow(scope, wrap);
    if (!row) {
      /* Kein passender Familien-Selector: native Optionszeile bleibt stehen. */
      decorateNative(scope, ralValue);
      wrap.setAttribute('data-bek-ral-injected', 'none');
      return;
    }
    /* TUBE rendert seine Finish-Varianten bereits direkt in der Farbzeile. */
    var existing = Array.from(row.querySelectorAll('.be-family-selector__option')).find(function (option) {
      return option.textContent.trim() === ralValue;
    });
    if (existing) return;

    var item = document.createElement('div');
    item.className = 'be-family-selector__item';
    item.setAttribute('role', 'listitem');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'be-family-selector__option bek-ral-opt';
    btn.setAttribute('data-bek-ral-pick', ralValue);
    btn.setAttribute('aria-pressed', 'false'); /* a11y (Claude, 2026-09-28): Auswahlknopf -> aria-pressed */
    btn.innerHTML = '<i class="bek-ral-dot" aria-hidden="true"></i>' + ralValue;
    item.appendChild(btn);
    row.appendChild(item);

    /* Die vorhandenen Farbknoepfe muessen zurueckschalten koennen. Der Knopf des
       aktuellen Produkts ist ein <span> ohne eigenen Handler, deshalb bekommt er
       hier eine Markierung und wird unten im Klick-Handler beruecksichtigt. */
    row.querySelectorAll('.be-family-selector__option').forEach(function (o) {
      if (o === btn) return;
      o.setAttribute('data-bek-ral-sibling', '1');
      if (o.tagName === 'A') {
        var url = new URL(o.href);
        url.searchParams.delete('variant');
        o.href = url.href;
      } else {
        o.setAttribute('role', 'button');
        o.setAttribute('tabindex', '0');
      }
      if (o.classList.contains('is-selected')) o.setAttribute('data-bek-ral-origsel', '1');
    });

    /* Native Optionszeile ausblenden, sie ist jetzt doppelt. */
    var h = wrap.getAttribute('data-option-handle');
    var n = wrap.getAttribute('data-option-name');
    var sel = [];
    if (h) sel.push('[data-handle="' + h + '"]');
    if (n) sel.push('[name="' + n + '"]');
    if (sel.length) {
      scope.querySelectorAll(sel.join(',')).forEach(function (el) {
        var vw = el.closest('.variant-wrapper');
        if (vw) vw.style.display = 'none';
      });
    }

    wrap.setAttribute('data-bek-ral-injected', '1');
  }

  /* a11y: aria-invalid setzen und die Fehler-ID nur bei sichtbarem Fehler an aria-describedby hängen. */
  function markInvalid(inp, err, on) {
    if (!inp) return;
    var id = err && err.id;
    var ids = (inp.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
    if (on) { inp.setAttribute('aria-invalid', 'true'); if (id) ids.push(id); }
    else inp.removeAttribute('aria-invalid');
    if (ids.length) inp.setAttribute('aria-describedby', ids.join(' '));
    else inp.removeAttribute('aria-describedby');
  }

  function sync(wrap) {
    var scope = scopeOf(wrap);
    var ralValue = wrap.getAttribute('data-ral-value') || 'Wunschfarbe RAL';
    var on = isRalSelected(scope, ralValue);

    wrap.hidden = !on;
    var inp = wrap.querySelector('[data-bek-ral-input]');
    if (inp) inp.disabled = !on;
    if (!on) {
      wrap.classList.remove('is-error');
      var err = wrap.querySelector('[data-bek-ral-error]');
      if (err) err.hidden = true;
      markInvalid(inp, err, false);
    }
    if (scope && scope !== document && scope.classList) {
      scope.classList.toggle('bek-ral-active', on);
    }

    /* Auswahlzustand in der Farbzeile spiegeln. */
    var pick = scope.querySelector('[data-bek-ral-pick]');
    if (pick) {
      pick.classList.toggle('is-selected', on);
      pick.setAttribute('aria-pressed', on ? 'true' : 'false');
      var rowEl = pick.closest('.be-family-selector__options');
      if (rowEl) {
        rowEl.querySelectorAll('[data-bek-ral-sibling]').forEach(function (o) {
          if (on) {
            o.classList.remove('is-selected');
          } else if (o.getAttribute('data-bek-ral-origsel') === '1') {
            o.classList.add('is-selected');
          }
          if (o.getAttribute('role') === 'button') o.setAttribute('aria-pressed', o.classList.contains('is-selected') ? 'true' : 'false');
        });
        var box = rowEl.closest('.be-family-selector');
        var info = box && box.querySelector('.variant__label-info');
        if (info) {
          if (on) {
            if (!info.getAttribute('data-bek-ral-orig')) {
              info.setAttribute('data-bek-ral-orig', info.textContent);
            }
            info.textContent = '— ' + ralValue;
          } else {
            var orig = info.getAttribute('data-bek-ral-orig');
            if (orig) info.textContent = orig;
          }
        }
      }
    }
  }

  function run(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('[data-bek-ral]').forEach(function (w) {
      inject(w);
      sync(w);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var pick = e.target.closest('[data-bek-ral-pick]');
    if (pick) {
      e.preventDefault();
      setNative(scopeOf(pick), pick.getAttribute('data-bek-ral-pick'));
      setTimeout(function () { run(); }, 0);
      return;
    }

    /* Zurueck auf die Lagerfarbe: der Knopf des aktuellen Produkts ist ein
       <span> und loest von sich aus nichts aus. Links auf Geschwisterprodukte
       laden ohnehin deren Standardvariante. */
    var sib = e.target.closest('[data-bek-ral-sibling]');
    if (sib && sib.tagName !== 'A') {
      var scope = scopeOf(sib);
      var wrap = scope.querySelector('[data-bek-ral]');
      if (wrap) {
        e.preventDefault();
        setNative(scope, wrap.getAttribute('data-ral-default') || 'Wie abgebildet');
        setTimeout(function () { run(); }, 0);
      }
      return;
    }

    if (e.target.closest('[data-variant-input]') || e.target.closest('[data-bek-finish]')) {
      setTimeout(function () { run(); }, 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-variant-input]')) run();
  });

  document.addEventListener('keydown', function (e) {
    var button = e.target.closest('[data-bek-ral-sibling][role="button"]');
    if (button && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      button.click();
    }
  });

  /* Kauf blockieren, solange die Wunschfarbe leer ist. Capture-Phase, damit der
     AJAX-Handler des Themes gar nicht erst startet. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var wrap = null;
    document.querySelectorAll('[data-bek-ral]').forEach(function (w) {
      var i = w.querySelector('[data-bek-ral-input]');
      if (i && i.form === form) wrap = w;
    });
    if (!wrap || wrap.hidden) return;
    var inp = wrap.querySelector('[data-bek-ral-input]');
    var val = inp ? String(inp.value || '').trim() : '';
    var err = wrap.querySelector('[data-bek-ral-error]');
    if (val.length < 3) {
      e.preventDefault();
      e.stopPropagation();
      wrap.classList.add('is-error');
      if (err) err.hidden = false;
      markInvalid(inp, err, true);
      try { wrap.scrollIntoView({ behavior: document.documentElement.classList.contains('bek-reduce-motion') ? 'auto' : 'smooth', block: 'center' }); } catch (e2) {}
      if (inp) inp.focus();
      return;
    }
    wrap.classList.remove('is-error');
    if (err) err.hidden = true;
    markInvalid(inp, err, false);
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-bek-ral-input]')) return;
    var wrap = e.target.closest('[data-bek-ral]');
    if (!wrap) return;
    if (String(e.target.value || '').trim().length >= 3) {
      wrap.classList.remove('is-error');
      var err = wrap.querySelector('[data-bek-ral-error]');
      if (err) err.hidden = true;
      markInvalid(e.target, err, false);
    }
  });

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if ((n.matches && n.matches('[data-bek-ral]')) || (n.querySelector && n.querySelector('[data-bek-ral]'))) {
          run(n.parentNode || document);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
